import { render } from "./UserAgentList.vue?vue&type=template&id=62f2a974&scoped=true"
import script from "./UserAgentList.vue?vue&type=script&lang=js"
export * from "./UserAgentList.vue?vue&type=script&lang=js"

import "./UserAgentList.vue?vue&type=style&index=0&id=62f2a974&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f2a974"]])

export default __exports__